.wrap {
  position: relative;
  height: 300px;
  overflow: hidden;
  /* Дуга уходит вниз за край контейнера — там её центр вращения. */
  mask-image: linear-gradient(to right, transparent, black 12%, black 88%, transparent);
}

.fan {
  position: absolute;
  /* Центр дуги ниже контейнера: карты расходятся веером вверх,
     как в руке. */
  left: 50%;
  bottom: calc(var(--card-w-lg) * -1.7);
  width: 0;
  height: 0;
  touch-action: pan-y;
  cursor: grab;
}

.dragging { cursor: grabbing; }

.slot {
  position: absolute;
  transform-origin: 50% 0;
  /* Во время перетаскивания следуем за пальцем один к одному:
     любой transition здесь читается как лаг. */
  margin-left: calc(var(--card-w-lg) / -2);
  margin-top: calc(var(--card-w-lg) / var(--card-ratio) * -1);
}
